import { atom, selector } from "recoil";
import { createDataRequest, updateDataRequest, getSlotTypeListRequest } from "../../../api/controller/SlotController";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const slotListState = atom({
    key: 'slotListState',
    default: [],
})
export const slotSlotTypeState = atom({
	key: 'slotSlotTypeState',
	default:{
		data:[],
		ovf:false,
	}
})

export const modalConfigDefault = { size: "lg", wizard: false }

export const slotFilterState = selector({
    key: 'slotFilterState',
    get: () => ([])
})


export const formModes = {
    create: [ { name: 'Default Create', action: createDataRequest } ], 
    update: [ { name: 'Default Update', action: updateDataRequest } ],
    view: [ { name: 'Default View' } ],
}

export const slotDataStructureState = selector({
    key: 'slotDataStructureState',
    get: ({ get }) => (
        [

            { 
                label: 'Slot Type',
                type: 'select',
                order: { table: 1, form: 1 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
				list: get(slotSlotTypeState),
				getRequest: getSlotTypeListRequest,
            },
			{ 
                label: 'Name',
                type: 'text',
                order: { table: 2, form: 2 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Description',
                type: 'text',
                order: { form: 3 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Start Price',
                type: 'number',
                order: { table: 4, form: 4 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Minimum Increment',
                type: 'number',
                order: { table: 5, form: 5 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Bid Start Time',
                type: 'datepicker',
                order: { table: 6, form: 6 }, 
				table: { dateFormat: 'MMM Do, HH:mm', postDateFormat:'YYYY-MM-DD HH:mm' },
                create: [{ enabled: true, size: { xs: 12, md: 6 } , dateFormat: 'YYYY-MM-DD HH:mm', options: { altInput: true, enableTime: true, time_24hr: true, altFormat: 'F j, Y H:i', dateFormat: 'Y-m-d H:i' } }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Bid End Time',
                type: 'datepicker',
                order: { table: 7, form: 7 }, 
				table: { dateFormat: 'MMM Do, HH:mm', postDateFormat:'YYYY-MM-DD HH:mm' },
                create: [{ enabled: true, size: { xs: 12, md: 6 } , dateFormat: 'YYYY-MM-DD HH:mm', options: { altInput: true, enableTime: true, time_24hr: true, altFormat: 'F j, Y H:i', dateFormat: 'Y-m-d H:i' } }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Image',
                type: 'file',
                order: { form: 8 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'X Coordinates',
                type: 'number',
                order: { form: 9 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Y Coordinates',
                type: 'number',
                order: { form: 10 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Winner',
                type: 'text',
                field: 'winner.display_name',
                order: { form: 11 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: { xs: 12, md: 12 }, validations: 'hidden_if:Winner,null' }], 
            },
			{ 
                label: 'Active',
                type: 'switch',
                order: { form: 11 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
